module.exports = __webpack_public_path__ + "eea525bf3e3d23508ca6a508da812ac8.svg";